import React from "react";


interface DivsProps {
    count: number;
}

export const Divs: React.FC<DivsProps> = ({ count }) => {
    const renderDivs = () => {
        const divs = [];
        for (let i = 0; i < count; i++) {
            divs.push(<div key={i}></div>);
        }
        return divs;
    };
    return <>{renderDivs()}</>;
};

export default Divs;